import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import curbsideAPIService from '../services/curbsideAPIService';

export const fetchOrdersLoad = createAsyncThunk(
  'loadOrders/fetchOrdersLoad',
  async ({ body, pageNumber, sortConfig, orderType }: { body: any; pageNumber: number; sortConfig: { direction: string; key: string }; orderType: string }) => {
    const endpoint = `orders?skip=${
      (pageNumber - 1) * 10
    }&take=10&sortDirection=${sortConfig.direction}&sortBy=${sortConfig.key}&orderType=${orderType}`;
    const response = await curbsideAPIService.post(endpoint, body);
    return response;
  }
);

export const fetchStoreData = createAsyncThunk('loadOrders/fetchStoreData', async () => {
  const response = await curbsideAPIService.get('store');
  return response;
});

export const fetchOrderDetailData = createAsyncThunk(
  'orderInfo/fetchOrderDetailData',
  async (orderId, { rejectWithValue }) => {
    try {
      const response = await curbsideAPIService.get(`orders/${orderId}`);
      return response;
    } catch (error) {
      console.error('Error fetching order data:', error);
      const errorMessage = (error as any)?.response?.data ?? 'Failed to fetch order data';
      return rejectWithValue(errorMessage);
    }
  }
);

const loadOrdersSlice = createSlice({
  name: 'loadOrders',
  initialState: {
    data: [],
    total: 0,
    loading: true,
    pageSize: 10,
    storeNames: [],
    orderDetails: null,
  },

  reducers: {
    setLoading: (state, action) => {
      return {
        ...state,
        loading: action.payload,
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrdersLoad.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(fetchOrdersLoad.fulfilled, (state, action) => {
        return {
          ...state,
          data: action.payload.items,
          total: action.payload.total,
          loading: false,
        };
      })
      .addCase(fetchOrdersLoad.rejected, (state) => {
        return {
          ...state,
          loading: false,
        };
      });
    builder.addCase(fetchStoreData.fulfilled, (state, action) => {
      return {
        ...state,
        storeNames: action.payload,
      };
    });
    builder.addCase(fetchOrderDetailData.fulfilled, (state, action) => {
      return {
        ...state,
        orderDetails: action.payload,
      };
    });
  },
});

export const { setLoading } = loadOrdersSlice.actions;
export default loadOrdersSlice.reducer;
